/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from "jquery";
import prestashop from "prestashop";
import ProductGallery from "./components/ProductGallery";
import SwiperSlider from "./components/SwiperSlider";
import ProductDropdownAttributes from "./components/productDropdownAttributes";
$(() => {
  let updateProductImages = false;
  createInputFile();
  createProductSpin();
  initProductAccordion();
  bindFeaturesToggleBtn();
  initUpdateProductPageUpdateAfterCartBeingUpdated();
  const dropdownAttributes = new ProductDropdownAttributes();
  const gallery = new ProductGallery();
  dropdownAttributes.init();
  gallery.init();
  prestashop.on("updateProduct", ({eventType}) => {
    if (typeof eventType !== "undefined" && eventType === "updatedProductCombination") {
      updateProductImages = true;
    } else {
      updateProductImages = false;
    }
  });
  prestashop.on("updatedProduct", (event) => {
    $(".product-add-to-cart").replaceWith(event.product_add_to_cart);
    dropdownAttributes.init();
    createInputFile();
    initNiceSelect();
    createProductSpin();
    if (updateProductImages) {
      $(".js-product-images-modal").replaceWith(event.product_images_modal);
      $(".js-images-container").replaceWith(event.product_cover_thumbnails);
      gallery.init();
    }
  });
  $(document).on("shown.bs.modal", "#product-modal", function(e) {
    const swiperSlider = new SwiperSlider({
      loop: $("#js-product-images-slider").data("length") > 1 ? 1 : 0
    });
    swiperSlider.init("#js-product-images-slider");
  });
  $(document).on("click", ".js-add-to-cart:enabled:not(is--loading)", function() {
    $(this).addClass("is--loading");
  });
  function initNiceSelect() {
    $("select:not(.niceselect-ignore)").niceSelect();
  }
});
function createProductSpin() {
  $("body").on("change keyup", "#quantity_wanted", (e) => {
    $(e.currentTarget).trigger("touchspin.stopspin");
    prestashop.emit("updateProduct", {
      eventType: "updatedProductQuantity",
      event: e
    });
  });
}
function createInputFile() {
  $(".js-file-input").on("change", (event) => {
    let target, file;
    if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
      $(target).prev().text(file.name);
    }
  });
}
function initUpdateProductPageUpdateAfterCartBeingUpdated() {
  prestashop.on("updateCart", (event) => {
    if (prestashop.page.page_name == "product" && event.reason.idProduct == $("#add-to-cart-or-refresh").find('[name="id_product"]').val()) {
      prestashop.emit("updateProduct", {
        event,
        resp: {},
        reason: {
          productUrl: prestashop.urls.pages.product || ""
        }
      });
    }
  });
}
function initProductAccordion() {
  $("#product-accordion .card:first-child .collapse").collapse("show");
}
function bindFeaturesToggleBtn() {
  $(document).on("click", '[data-action="show-features"]', (e) => {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const $hiddenFeatures = $(".product-features__elem.d-none");
    $hiddenFeatures.removeClass("d-none");
    $btn.hide();
  });
}
if (module.hot) { module.hot.accept(); }